// Modal.js
import React from "react";
import { IoClose } from "react-icons/io5";

const Modal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    content,
    cancelText,
    confirmText,
    buttonType, // New prop to determine button type (success or error)
}) => {
    if (!isOpen) return null; // Don't render if modal is not open

    const buttonClasses = (type) => {
        if (type === "error") {
            return "bg-red-600 hover:bg-red-800"; // Red for error
        }
        return "bg-blue-shades hover:bg-primary"; // Blue for success
    };

    const titleClasses = (type) => {
        if (type === "error") {
            return "text-red-600"; // Red for error title
        }
        return "text-primary"; // Blue for success title
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white font-inter p-6 rounded-lg shadow-lg min-w-[300px]  w-2/3 sm:w-1/2 lg:w-1/3 relative">
                {/* Close button on top-right corner */}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray hover:text-gray-700"
                >
                    <IoClose className="h-6 w-6" />
                </button>

                <h2
                    className={`text-2xl font-semibold mb-4 ${titleClasses(
                        buttonType
                    )}`}
                >
                    {title}
                </h2>
                <p className="mb-4 text-gray">{content}</p>

                <div className="flex flex-col md:flex-row justify-end  md:space-x-4 mt-6">
                    {/* Cancel button */}
                    <button
                        onClick={onClose}
                        className={`text-white bg-gray px-6 py-2 rounded-[4px]`}
                    >
                        {cancelText || "Cancel"}
                    </button>

                    {/* Confirm button */}
                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className={`text-white px-6 py-2 mt-4 md:mt-0 rounded-[4px] ${buttonClasses(
                            buttonType
                        )}`}
                    >
                        {confirmText || "Confirm"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
